// iOS app identifier logic. Android TBD.
const isWebViewUrl = window.location.href.toLowerCase().includes('webview');
const isWebViewUserAgent = /CarvanaNativeWebView/gi.test(navigator.userAgent);

export const getIsNativeMobileApp = () => isWebViewUrl || isWebViewUserAgent;
